import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useChat } from "../context/ChatContext";
import ChatConversation from "./ChatConversation";

export default function ChatWidget() {
  const { open, setOpen } = useChat();

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 backdrop-blur-sm md:items-end md:justify-end md:p-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          >
            <motion.div
              data-testid="chat-modal"
              onClick={(e) => e.stopPropagation()}
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 40, opacity: 0 }}
              transition={{ type: "spring", damping: 26, stiffness: 280 }}
              className="relative w-full max-w-md overflow-hidden rounded-t-2xl border border-white/10 bg-[#14161B] md:rounded-2xl"
            >
              <button
                data-testid="chat-close-btn"
                onClick={() => setOpen(false)}
                className="absolute right-3 top-3 z-10 text-gray-400 hover:text-white"
                aria-label="Schließen"
              >
                <X size={20} />
              </button>
              <ChatConversation variant="modal" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
